module.exports = __webpack_public_path__ + "media/lounge.c8940e88.wav";